var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11816",
    "data-name": "Group 11816",
    transform: "translate(-42.197 -98.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    transform: "translate(42.197 98.363)",
    fill: "#fff",
    stroke: "#393939",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M110.9,183.812c.176-.214.34-.413.5-.611.195-.234.391-.466.586-.7.209-.252.415-.506.626-.757.277-.329.556-.656.834-.983.064-.076.128-.152.2-.225a.582.582,0,0,1,.64-.177.607.607,0,0,1,.431.509.57.57,0,0,1-.115.438c-.122.172-.256.337-.391.5q-.823.993-1.65,1.983c-.368.442-.733.887-1.107,1.325a.64.64,0,0,1-.991.044l-.454-.459q-.591-.6-1.181-1.191-.129-.13-.252-.267a.606.606,0,0,1,.294-1.008.58.58,0,0,1,.517.1,2.363,2.363,0,0,1,.247.214c.39.391.776.786,1.165,1.178.029.029.063.054.1.087",
    transform: "translate(-61.207 -76.964)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.d33d45eaf7e493c5039575388bb8c8a8.svg";
export { ForwardRef as ReactComponent };